import React, { Component } from 'react'
import Menu from '../Menu'
import Vimeo from '../Vimeo'
import styles from './TourAuslan.css'

export default class Auslan extends Component {
  state = {video: null}
  handleItemClick = (item) => {
    this.setState({video: item.auslan})
  }

  handleCloseClick = () => {
    this.setState({video: null})
  }

  render () {
    return (
      <div className={styles.cont}>
        <Menu logo={this.props.logo} menu={this.props.menu} linkBack/>
        <div className={styles.main}>
          {this.props.items.filter(item => item.auslan).map((item, itemKey) => (
            <Item key={itemKey} itemKey={itemKey} item={item} onClick={this.handleItemClick}/>
          ))}
        </div>
        {this.state.video && (
          <Video video={this.state.video} onCloseClick={this.handleCloseClick}/>
        )}
      </div>
    )
  }
}

class Item extends Component {
  handleClick = () => {
    this.props.onClick(this.props.item)
  }
  render () {
    return (
      <div
        className={styles.item}
        style={{
          backgroundImage: 'url('+this.props.item.image+')',
          backgroundPosition: this.props.item.imagePosition || '',
        }}
        onClick={this.handleClick}
      >
        <div className={styles.heroTitle}>
          {this.props.item.primaryTitle}
        </div>
        <div className={styles.heroRoomNumber}>
          {this.props.itemKey + 1}
        </div>
        <div className={styles.heroYear}>
          — {this.props.item.year}
        </div>

        <div className={styles.enterButton}>
          PLAY AUSLAN
        </div>
      </div>
    )
  }
}

class Video extends Component {
  handleCloseClick = () => {
    this.props.onCloseClick()
  }
  render () {
    return (
      <div className={styles.video}>
        <Vimeo video={this.props.video} noImage/>
        <div className={styles.closeVideo} onClick={this.handleCloseClick}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/TourAuslan/index.js